<h3>
  Face Detection
</h3>
<div class="row">
  <div class="col-xm-12 col-sm-12 col-md-9 col-lg-9 col-xl-9">
    <div class="center-content page-container">
      <div *ngIf="faceApiService.loading">
        <div class="loader">
        </div>
      </div>
      <div style="position: relative; height: auto;width: auto" class="margin">
        <video (loadedmetadata)="onPlay()" id="inputVideo" autoplay muted playsinline></video>
        <canvas id="overlay"></canvas>
      </div>
    </div>
  </div>
  <div class="col-xm-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
    <app-face-api-config [showBoxes]="false"></app-face-api-config>
  </div>
</div>
